import React, { useEffect, useState } from "react";
import { Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { offerService } from "../../Services";
import { InfluencerRating } from "../../Components";

const OfferDetails = ({ open, onClose, applicationId, applicaitonData }) => {
  console.log("🚀 ~ OfferDetails ~ applicaitonData:", applicaitonData);
  const [applicationDetails, setApplicationDetails] = useState(null);
  console.log("🚀 ~ OfferDetails ~ applicationDetails:", applicationDetails);
  const [loading, setLoading] = useState(false);
  const { application, campaign } = applicationDetails || {};
  // const userLogin = getUserData();

  const currentUrl = window.location.href;
  const isBrand = window.location.href.includes("/brand/");
  console.log("🚀 ~ OfferDetails ~ isBrand:", isBrand);

  useEffect(() => {
    if (open && applicationId) {
      fetchApplicationData(applicationId);
    }
  }, [applicationId]);

  // const getStatusColor = (status) => {
  //   const statusValue = status?.toLowerCase();
  //   switch (statusValue) {
  //     case "draft":
  //       return "warning";
  //     case "pending":
  //     case "offered":
  //       return "info";
  //     case "open":
  //     case "active":
  //     case "complete":
  //       return "success";
  //     case "pause":
  //     case "paused":
  //       return "warning";
  //     case "delete":
  //     case "deleted":
  //     case "archive":
  //     case "archived":
  //     case "close":
  //     case "closed":
  //       return "error";
  //     default:
  //       return "default";
  //   }
  // };
  function capitalizeFirstLetter(val) {
    return String(val)?.charAt(0)?.toUpperCase() + String(val)?.slice(1);
  }

  const statusRender = (status) => {
    const baseStyle =
      "inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium";

    switch (status) {
      case "cancel_requested":
        return (
          <span className={`${baseStyle} bg-yellow-100 text-yellow-700`}>
            {status
              ?.replace(/_/g, " ")
              ?.replace(/\b\w/g, (c) => c.toUpperCase())}
          </span>
        );
      case "pending":
        return (
          <span className={`${baseStyle} bg-gray-100 text-gray-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "offered":
        return (
          <span className={`${baseStyle} bg-blue-100 text-blue-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "draft":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "active":
        return (
          <span className={`${baseStyle} bg-green-100 text-green-700`}>
            active
          </span>
        );
      case "open":
        return (
          <span className={`${baseStyle} bg-green-100 text-green-700`}>
            open
          </span>
        );
      case "complete":
        return (
          <span className={`${baseStyle} bg-green-100 text-green-700`}>
            complete
          </span>
        );

      case "paused":
        return (
          <span
            className={`${baseStyle} bg-yellow-100 text-yellow-700`}
            title="Waiting for the brand’s acceptance"
          >
            <span>paused</span>
          </span>
        );
      case "pause":
        return (
          <span
            className={`${baseStyle} bg-yellow-100 text-yellow-700`}
            title="Waiting for the brand’s acceptance"
          >
            <span>pause</span>
          </span>
        );

      case "delete":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>delete</span>
          </span>
        );
      case "deleted":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>deleted</span>
          </span>
        );
      case "archive":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>archive</span>
          </span>
        );
      case "archived":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>archived</span>
          </span>
        );
      case "close":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>close</span>
          </span>
        );
      case "closed":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>closed</span>
          </span>
        );

      default:
        return (
          <span className={`${baseStyle} bg-gray-100 text-gray-600`}>
            {capitalizeFirstLetter(status)}
          </span>
        );
    }
  };

  const getPlatformIcon = (platformCode) => {
    const id = platformCode?.toString();

    switch (id) {
      case "IG":
        return (
          <div className="flex gap-2">
            <img
              src="/images/instagram.svg"
              alt="Instagram"
              width="24"
              height="24"
            />
          </div>
        );
      case "TT":
        return (
          <div className="flex gap-2">
            <img
              src="/images/tiktok-logo.svg"
              alt="TikTok"
              width="24"
              height="24"
            />
          </div>
        );
      case "FB":
        return (
          <div className="flex gap-2">
            <img
              src="/images/facebook.svg"
              alt="Facebook"
              width="24"
              height="24"
            />
          </div>
        );
      case "YT":
        return (
          <div className="flex gap-2">
            <img
              src="/images/youtube.svg"
              alt="Facebook"
              width="24"
              height="24"
            />
          </div>
        );
      default:
        return <span>{platformCode || "NA"}</span>;
    }
  };

  const fetchApplicationData = async (id) => {
    try {
      setLoading(true);
      // const res = await offerService.getApplicationData(id);
      const res = await offerService.getOfferDetailsByOfferId(id);

      let parsed;
      if (typeof res === "string") {
        parsed = JSON.parse(res);
        if (typeof parsed === "string") {
          parsed = JSON.parse(parsed);
        }
      } else {
        parsed = res;
      }

      if (parsed.success === true || parsed.success === "true") {
        setApplicationDetails(parsed.data);
      } else {
        console.error("API returned unsuccessful response:", parsed);
      }
    } catch (error) {
      console.error("Error fetching application data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !applicationDetails) {
    return (
      <Modal open={open} onClose={onClose}>
        <div className="flex items-center justify-center p-4 min-h-screen">
          <div className="bg-white rounded-lg p-8">
            <p>Loading offer details...</p>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="application-details-modal"
      aria-describedby="application-details-description"
      className="flex items-center justify-center p-4"
    >
      <div className="relative w-full max-w-4xl max-h-[90vh] bg-white rounded-xl shadow-2xl outline-none overflow-hidden">
        <div className="sticky top-0 z-10 flex justify-between items-center p-6 py-3 border-b border-gray-200 bg-gradient-to-r from-green-600 to-green-700 text-white">
          {!isBrand ? (
            <div>
              <Typography
                variant="h5"
                component="h2"
                className="font-bold text-white"
              >
                {applicationDetails?.product_name || "Untitled Campaign"}
              </Typography>
              <span className="text-sm text-green-950 font-medium italic">
                by {applicationDetails?.from_displayname}
              </span>
            </div>
          ) : (
            <div>
              {" "}
              <Typography
                variant="h5"
                component="h2"
                className="font-bold text-white"
              >
                {application?.inf_displayname || "Untitled Campaign"}
              </Typography>
            </div>
          )}

          <IconButton
            onClick={onClose}
            className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors"
            aria-label="close"
          >
            <CloseIcon className="text-white" />
          </IconButton>
        </div>

        {!isBrand ? (
          <div className="overflow-y-auto max-h-[calc(90vh-88px)]">
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  <div className="md:col-span-2">
                    <div className="bg-gray-50 p-6 rounded-lg flex justify-between items-start">
                      <div className="flex items-start space-x-6 flex-1">
                        <img
                          // src={
                          //   applicationDetails?.from_profile_img_url ||
                          //   `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                          // }
                          src={
                            applicaitonData?.from_profile_img_url ||
                            `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                          }
                          alt={
                            applicationDetails?.from_profile_img_url ||
                            "Influencer"
                          }
                          className="w-20 h-20 rounded-full object-cover flex-shrink-0"
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                          }}
                        />
                        <div className="flex-1">
                          <p className="text-xl font-bold text-gray-900 mb-2">
                            {/* {applicationDetails?.to_displayname || "N/A"} */}
                            {applicaitonData?.from_displayname || "N/A"}
                          </p>
                          <div className="mb-4">
                            <InfluencerRating
                              infrating={applicationDetails?.to_rating}
                            />
                          </div>
                          <div className="flex gap-8">
                            <div className="text-center">
                              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                                Followers
                              </p>
                              <p className="text-lg text-gray-900">
                                {applicationDetails?.to_followers?.toLocaleString() ||
                                  "N/A"}
                              </p>
                            </div>
                            <div className="text-center">
                              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                                Engagement Rate
                              </p>
                              <p className="text-lg text-gray-900">
                                {applicationDetails?.to_engagement_rate
                                  ? `${applicationDetails.to_engagement_rate}%`
                                  : "N/A"}
                              </p>
                            </div>
                            {applicationDetails.price && (
                              <div className="text-center">
                                <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                                  Asking Price
                                </p>
                                <p className="text-lg text-gray-900">
                                  {applicationDetails.price
                                    ? `$ ${applicationDetails.price}`
                                    : "NA"}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col items-center gap-2 px-3 py-2  min-w-[150px]">
                        <p className="text-lg text-center">
                          Status :{statusRender(applicationDetails.status)}
                        </p>
                        {/* <p className="text-lg text-green-600 text-center">
                          Offered : ${applicaitonData?.price}
                        </p> */}
                      </div>
                    </div>
                  </div>
                  {/* {campaign?.brand_name && (
                  <div className="md:col-span-2">
                    <div className="bg-blue-50 p-4 rounded-lg mb-6">
                      <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                        🏢 Brand Information
                      </p>
                      <div className="flex items-center space-x-4">
                        {campaign.brand_photo_url && (
                          <img
                            src={
                              campaign.brand_photo_url ||
                              `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                            }
                            alt={campaign.brand_name}
                            className="w-16 h-16 rounded-lg object-cover"
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                            }}
                          />
                        )}
                        <div>
                          <p className="text-lg font-semibold text-gray-900">
                            {campaign.brand_name}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
                  {/* 
                  {(campaign?.compensation ||
                    campaign?.scope_of_work ||
                    campaign?.delivery_info ||
                    campaign?.additional_info) && (
                    <div className="md:col-span-2">
                      <p className="text-xl font-semibold text-gray-900 mb-1">
                        Campaign Information
                      </p>
                    </div>
                  )} */}
                  {/* <div className="space-y-4">
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Delivery Date
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {campaign?.delivery_date
                          ? new Date(
                              campaign.delivery_date
                            ).toLocaleDateString()
                          : "Not specified"}
                      </p>
                    </div>
                  </div>
                  {campaign?.apply_by_date && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Apply By Date
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {campaign?.apply_by_date
                          ? new Date(
                              campaign.apply_by_date
                            ).toLocaleDateString()
                          : "Not specified"}
                      </p>
                    </div>
                  )} */}
                  {/* {campaign?.category_name && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Category
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {campaign?.category_name || "Not specified"}
                      </p>
                    </div>
                  )}
                  {campaign?.platform_name && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Platform
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {campaign.platform_name}
                      </p>
                    </div>
                  )}
                  {campaign?.reach_min && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Minimum Reach
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {campaign.reach_min?.toLocaleString()}
                      </p>
                    </div>
                  )}
                  {application?.social_media_code && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Social Platform
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {getPlatformIcon(application.social_media_code)}
                      </p>
                    </div>
                  )}
                  {campaign?.location_name && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Location
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {campaign?.location_name}
                      </p>
                    </div>
                  )} */}

                  {/* {campaign?.rate && (
                    <div className="">
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        My Rate
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {campaign?.rate}
                      </p>
                    </div>
                  )} */}
                  {applicationDetails?.social_media_code && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Social Platform
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {getPlatformIcon(applicationDetails.social_media_code)}
                      </p>
                    </div>
                  )}

                  {applicationDetails?.description && (
                    <div className="md:col-span-2">
                      <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                        Description
                      </p>
                      <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                        <p className="text-base text-gray-900 font-medium">
                          {applicationDetails?.description}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* {campaign?.scope_of_work && (
                    <div className="md:col-span-2">
                      <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                        Scope of Work
                      </p>
                      <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                          {campaign.scope_of_work}
                        </p>
                      </div>
                    </div>
                  )}

                  {campaign?.delivery_info && (
                    <div className="md:col-span-2">
                      <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                        Delivery Information
                      </p>
                      <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                          {campaign.delivery_info}
                        </p>
                      </div>
                    </div>
                  )}

                  {campaign?.additional_info && (
                    <div className="md:col-span-2 ">
                      <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                        Additional Information
                      </p>
                      <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                          {campaign.additional_info}
                        </p>
                      </div>
                    </div>
                  )} */}
                  {(applicationDetails?.created_at ||
                    applicationDetails?.updated_at) && (
                    <div className="md:col-span-2">
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="flex justify-between items-center flex-wrap gap-2">
                          {applicationDetails?.created_at && (
                            <div className="flex items-center gap-2">
                              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Created:
                              </span>
                              <span className="text-sm text-gray-700 font-medium">
                                {new Date(
                                  applicationDetails?.created_at
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                  timeZone: "UTC",
                                })}
                              </span>
                            </div>
                          )}
                          {applicationDetails?.updated_at && (
                            <div className="flex items-center gap-2">
                              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Updated:
                              </span>
                              <span className="text-sm text-gray-700 font-medium">
                                {new Date(
                                  applicationDetails.updated_at
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                  timeZone: "UTC",
                                })}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>
        ) : (
          <div className="overflow-y-auto max-h-[calc(90vh-88px)]">
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  <div className="md:col-span-2">
                    <div className="bg-gray-50 p-6 rounded-lg flex justify-between items-start">
                      <div className="flex items-start space-x-6 flex-1">
                        <img
                          src={
                            application?.inf_profile_img_url ||
                            `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                          }
                          alt={application?.inf_displayname || "Influencer"}
                          className="w-20 h-20 rounded-full object-cover flex-shrink-0"
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                          }}
                        />
                        <div className="flex-1">
                          <p className="text-xl font-bold text-gray-900 mb-2">
                            {application?.inf_displayname || "N/A"}
                          </p>
                          <div className="mb-4">
                            <InfluencerRating
                              infrating={application?.inf_rating}
                            />
                          </div>
                          <div className="flex gap-8">
                            <div className="text-center">
                              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                                Followers
                              </p>
                              <p className="text-lg text-gray-900">
                                {application?.inf_followers?.toLocaleString() ||
                                  "N/A"}
                              </p>
                            </div>
                            <div className="text-center">
                              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                                Engagement Rate
                              </p>
                              <p className="text-lg text-gray-900">
                                {application?.inf_engagement_rate
                                  ? `${application.inf_engagement_rate}%`
                                  : "N/A"}
                              </p>
                            </div>
                            {application?.rate && (
                              <div className="text-center">
                                <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                                  Asking Price
                                </p>
                                <p className="text-lg text-gray-900">
                                  {application?.rate
                                    ? `$ ${application?.rate}`
                                    : "NA"}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col items-center gap-2 px-3 py-2  min-w-[150px]">
                        <p className="text-lg text-center">
                          Status : {capitalizeFirstLetter(application?.status)}
                        </p>
                        {/* <p className="text-lg text-green-600 text-center">
                          Offered : ${applicaitonData?.price}
                        </p> */}
                      </div>
                    </div>
                    {application?.note && (
                      <div className="mt-3 bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm font-semibold text-gray-600 mb-1">
                          Message:
                        </p>
                        <p className="text-base text-gray-800">
                          {application?.note}
                        </p>
                      </div>
                    )}
                  </div>
                  {application?.social_media_code && (
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Social Platform
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {getPlatformIcon(application.social_media_code)}
                      </p>
                    </div>
                  )}

                  {(application?.created_at || application?.updated_at) && (
                    <div className="md:col-span-2">
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="flex justify-between items-center flex-wrap gap-2">
                          {application?.created_at && (
                            <div className="flex items-center gap-2">
                              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Created:
                              </span>
                              <span className="text-sm text-gray-700 font-medium">
                                {new Date(
                                  application?.created_at
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                  timeZone: "UTC",
                                })}
                              </span>
                            </div>
                          )}
                          {application?.updated_at && (
                            <div className="flex items-center gap-2">
                              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Updated:
                              </span>
                              <span className="text-sm text-gray-700 font-medium">
                                {new Date(
                                  application.updated_at
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                  timeZone: "UTC",
                                })}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default OfferDetails;
